import Icon from "../../assets/icons/Icon";
import React, { useState, useEffect, useRef } from "react";
import Button from "./Button";
import { isMobileView } from "./CommonFunctions";

const CustomToast = ({ 
  message, 
  type = "info", 
  primaryBtnText = "Continue", 
  secondaryBtnText = "Cancel", 
  onPrimaryClick,
  loading=false,
  onSecondaryClick,
  onClose,
  duration = 10000
}) => {
  const [progress, setProgress] = useState(100);
  const [visible, setVisible] = useState(true);
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  const remainingTimeRef = useRef(duration);

  const toastStyles = {
    success: {
      bg: "bg-green-500",
      hover: "hover:bg-green-600",
      color: "#22c55e",
      hoverColor: "#16a34a"
    },
    error: {
      bg: "bg-red-500",
      hover: "hover:bg-red-600",
      color: "#ef4444",
      hoverColor: "#dc2626"
    },
    warning: {
      bg: "bg-yellow-500",
      hover: "hover:bg-yellow-600",
      color: "#eab308",
      hoverColor: "#ca8a04"
    },
    info: {
      bg: "bg-blue-500",
      hover: "hover:bg-blue-600",
      color: "#3b82f6",
      hoverColor: "#2563eb"
    }
  };

  const style = toastStyles[type] || toastStyles.info;

  useEffect(() => {
    startProgress();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const startProgress = () => {
    startTimeRef.current = Date.now();
    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTimeRef.current;
      const newProgress = 100 - (elapsed / duration) * 100;

      if (newProgress <= 0) {
        setProgress(0);
        clearInterval(intervalRef.current);
        setVisible(false);
        if (onClose) onClose();
      } else {
        setProgress(newProgress);
        remainingTimeRef.current = duration - elapsed;
      }
    }, 50);
  };

  const pauseProgress = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const resumeProgress = () => {
    startProgress();
  };

  const handleClose = () => {
    setVisible(false);
    if (onClose) onClose();
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div 
        className={`fixed ${isMobileView() ? "top-0" : "top-4 rounded-lg"} left-1/2 transform -translate-x-1/2 max-w-md w-full shadow-lg bg-white z-50`}
        onMouseEnter={pauseProgress}
        onMouseLeave={resumeProgress}
      >
        {/* Header */}
        <div className="flex justify-between p-3 border-b border-gray-100">
          <div className={`${style.bg} rounded-full p-1 h-[25px] w-[25px]`}>
            <Icon type="alert-circle" />
          </div>

          <p className="font-medium text-gray-800 max-w-xs">
            {message}
          </p>

          <span 
            onClick={handleClose}
            className="w-5 text-gray-500 hover:text-gray-700 cursor-pointer"
          >
            <Icon type="remove" />
          </span>
        </div>

        {/* Progress bar */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
          <div
            className={`h-full ${style.bg}`}
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Buttons */}
        {(primaryBtnText || secondaryBtnText) && (
          <div className="px-4 pb-3 pt-2 flex justify-end space-x-2 bg-gray-50">
            {secondaryBtnText && (
              <Button type="secondary" disabled={loading} onClick={onSecondaryClick}>
                {secondaryBtnText}
              </Button>
            )}

            {primaryBtnText && (
              <button
  onClick={onPrimaryClick}
  className={`px-4 font-medium text-white rounded-md h-[34px] shadow-sm 
    ${loading ? "cursor-not-allowed opacity-60" : "cursor-pointer"} 
    ${style.bg} ${style.hover}`}
  style={{
    backgroundColor: style.color
  }}
  disabled={loading}
  onMouseOver={(e) => {
    if (!loading) {
      e.currentTarget.style.backgroundColor = style.hoverColor;
    }
  }}
  onMouseOut={(e) => {
    if (!loading) {
      e.currentTarget.style.backgroundColor = style.color;
    }
  }}
>
  {loading ? "Loading..." : primaryBtnText}
</button>

            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomToast;
